export default () => ({
  dasbhoard: null
})



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/state.js